import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, where, orderBy } from 'firebase/firestore';
import { db } from '../../firebase';
import { useAuth } from '../../contexts/AuthContext';
import DashboardLayout from '../../components/DashboardLayout';
import { SessionCard } from '../coach/CoachCompanyPage';

export default function BeneficiarySessionsPage() {
  const { profile } = useAuth();
  const [sessions, setSessions]   = useState([]);
  const [companyDocId, setCompanyDocId] = useState(null);
  const [loading, setLoading]     = useState(true);
  const [expandedSession, setExpanded] = useState(null);

  useEffect(() => {
    if (!profile?.uid) return;
    async function load() {
      try {
        const cSnap = await getDocs(
          query(collection(db, 'companies'), where('memberUids', 'array-contains', profile.uid))
        );
        if (cSnap.empty) { setLoading(false); return; }
        const cId = cSnap.docs[0].id;
        setCompanyDocId(cId);
        const sSnap = await getDocs(
          query(collection(db, 'companies', cId, 'coachingSessions'), orderBy('sessionDate', 'desc'))
        );
        setSessions(sSnap.docs.map(d => ({ id: d.id, ...d.data() })));
      } catch (err) { console.error(err); }
      finally { setLoading(false); }
    }
    load();
  }, [profile]);

  const myOpenActions = sessions.flatMap(s =>
    (s.actionItems || []).filter(a => a.status === 'open' && a.assignedTo === 'beneficiary')
  );

  return (
    <DashboardLayout>
      <div className="gm-page">
        <div className="gm-page-header">
          <div>
            <h1 className="gm-page-title">Coaching Sessions</h1>
            <p className="gm-page-sub">Your session history and action items</p>
          </div>
        </div>

        {loading && <div className="gm-loading"><div className="gm-spinner" /></div>}

        {!loading && (
          <>
            {myOpenActions.length > 0 && (
              <div className="gm-section">
                <h2 className="gm-section-title">Your open actions</h2>
                <div className="gm-action-items-list">
                  {myOpenActions.map((a, idx) => (
                    <div key={idx} className="gm-action-item gm-action-item--open">
                      <div className="gm-action-item-left">
                        <span className="gm-action-check">○</span>
                        <span className="gm-action-item-text">{a.text}</span>
                      </div>
                      {a.dueDate && <span className="gm-action-due">Due {new Date(a.dueDate).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}</span>}
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="gm-section">
              <h2 className="gm-section-title">{sessions.length} session{sessions.length !== 1 ? 's' : ''} logged</h2>

              {sessions.length === 0 && (
                <div className="gm-empty-state">
                  <p>No sessions logged yet. Your coach will add sessions after each meeting.</p>
                </div>
              )}

              {sessions.map(session => (
                <SessionCard
                  key={session.id}
                  session={session}
                  companyId={companyDocId}
                  isExpanded={expandedSession === session.id}
                  onToggle={() => setExpanded(expandedSession === session.id ? null : session.id)}
                  onToggleAction={() => {}}
                  isCoach={false}
                  profile={profile}
                  readOnly={false}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </DashboardLayout>
  );
}
